import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'
import useDebounce from 'hooks/environment/useDebounce'
import useIsWindowVisible from 'hooks/environment/useIsWindowVisible'
import { useEffect, useState } from 'react'
import { api, CHAIN_TAG } from 'state/data/enhanced'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { supportedNetworkId } from 'utils/supportedNetworkId'

import { updateChainId } from './reducer'

function useQueryCacheInvalidator() {
  const dispatch = useAppDispatch()

  // subscribe to `networkId` changes in the redux store rather than Web3
  // this will ensure that when `invalidateTags` is called, the latest
  // `networkId` is available in redux to build the subgraph url
  const networkId = useAppSelector((state) => state.application.networkId)

  useEffect(() => {
    dispatch(api.util.invalidateTags([CHAIN_TAG]))
  }, [networkId, dispatch])
}

export default function Updater(): null {
  const { networkId, library } = useActiveWeb3()
  const dispatch = useAppDispatch()
  const windowVisible = useIsWindowVisible()

  const [activeChainId, setActiveChainId] = useState(networkId)

  useQueryCacheInvalidator()

  useEffect(() => {
    if (library && networkId && windowVisible) {
      setActiveChainId(networkId)
    }
  }, [dispatch, networkId, library, windowVisible])

  const debouncedChainId = useDebounce(activeChainId, 100)

  useEffect(() => {
    const networkId = debouncedChainId ? supportedNetworkId(debouncedChainId) ?? null : null
    dispatch(updateChainId({ networkId }))
  }, [dispatch, debouncedChainId])

  return null
}
